export function getCurrentSecond() {
  return Math.floor(new Date().getTime() / 1000);
}

const DAY = 24 * 3600;

export function isOpenNow({
  elapsed, // seconds since page rendered
  startupSecond, // time page rendered (seconds since midnight in server zone)
  openSecond, // time chat opens (seconds since midnight in server zone)
  closeSecond // time chat closes (seconds since midnight in server zone)
}) {
  // if (isNaN(startupSecond) || isNaN(elapsed) ||
  //   isNaN(openSecond) || isNaN(closeSecond)) {
  //   console.warn("Invalid")
  //   return false;
  // }

  const thisSecond = (+startupSecond + elapsed) % DAY;

  return (
    (thisSecond >= +openSecond) &&
    (thisSecond < +closeSecond) )
}

export function timeToClose({
  elapsed, // seconds since page rendered
  startupSecond, // time page rendered (seconds since midnight in server zone)
  openSecond, // time chat opens (seconds since midnight in server zone)
  closeSecond // time chat closes (seconds since midnight in server zone)
}) {
    const thisSecond = (+startupSecond + elapsed) % DAY;
    return closeSecond - thisSecond;
}
